export default "__VITE_ASSET__016243d7__"